export default "__VITE_ASSET__5093cb37__"